<template>
  <validation-observer ref="cardManagement">
    <div class="row">
      <div class="col-md-12 text-bold bold mb-3">
        <i class=" fa fa-file-search color-orange" />
        Gestiones realizadas
      </div>
      <div class="col-md-12 mt-2">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="model.managementTypeId"
            :clearable="false"
            custom-error-msg="Favor seleccionar Tipo de Gestión."
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Tipo de gestión:"
            :options="managementTypes"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div class="col-md-12 mt-2">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="model.comment"
            :clearable="false"
            custom-error-msg="Favor escribir un comentario."
            :error="errors[0]"
            label="Comentario:"
            :maxlength="500"
            :rows="4"
            show-char-count
          />
        </validation-provider>
      </div>

      <div class="col-md-12 text-right mt-3 pt-1">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3"
          @click="$emit('on-cancel')"
        />
        <action-button
          i="fas fa-save"
          text="Guardar"
          variant="success"
          @click="submit"
        />
      </div>

      <div class="col-md-12 compact-calendar-container">
        <card-management-result :id="id" ref="cardManagementResult" />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import alertMixin from '@/mixins/alert.mixin';
import CustomDropDown from 'custom-drop-down';
import { getCardManagementTypes } from '@/modules/shared/code.api';
import { postManagement } from '@/modules/shared/cardHandling.api';
import CardManagementResult from './CardManagementResult';
export default {
  name: 'CardManagement',
  components: {
    CustomTextArea,
    CustomDropDown,
    CardManagementResult,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      default: 0,
      require: true,
    },
  },
  data: () => ({
    model: {
      Id: null,
      becaCardId: null,
      managementTypeId: null,
      comment: null,
    },
    managementTypes: [],
  }),
  async mounted() {
    let data = await getCardManagementTypes();
    this.managementTypes = data.data;
  },
  methods: {
    async submit() {
      const isValid = await this.$refs.cardManagement.validate();
      if (isValid) {
        this.model.becaCardId = this.id;
        let model = {
          Id: this.model.id,
          BecaCardManagementTypeId: this.model.managementTypeId.id,
          Comment: this.model.comment,
          becaCardId: this.model.becaCardId,
        };
        postManagement(model)
          .then(() => {
            this.ShowToast(
              'Confirmación',
              'La gestión ha sido documentada exitosamente.',
              'success'
            );
            this.$refs.cardManagementResult.getManagements();
            this.model = {
              Id: null,
              becaCardId: null,
              managementTypeId: null,
              comment: null,
            };
            this.$refs.cardManagement.reset();
          })
          .catch((err) => {
            if (err && err.response && err.response.data) {
              this.ShowToast('Error', err.response.data.message, 'error');
            } else {
              this.ShowToast('Error', err.message, 'error');
            }
          });
      }
    },
  },
};
</script>
<style lang="scss"></style>
